<a [buttonStyle]
   [routerLink]="url"
   (click)="track()"
   cy-checkoutProceed
   class="w-12">
    {{'checkout securely'|translate}}
</a>